<template>
    <div>
        <el-dialog
                append-to-body
                :fullscreen="dialogFull"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                :before-close="handleClose"
                title="取 消"
                :visible.sync="dialogShow"
                width="50%"
                :modal-append-to-body="false">
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        {{title}}
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                        </div>
                        <el-divider></el-divider>
                </template>
            <avue-form
                :option="option"
                v-model="form"
                v-if="dialogShow"
                @submit="formSubmit"
                @error="formError">
                    <template slot="delayEndTime">

              <el-date-picker
                style="width: 100%"
                v-model="form.delayEndTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                placeholder="挂起截止时间"
              >
              </el-date-picker>
                    </template>
                 <template slot="remark">
                <div>
                        <el-input
                                type="textarea"
                                :rows="3"
                                maxlength="500"
                                show-word-limit
                                placeholder="请输入 备注"
                                v-model="form.remark"
                        >
                        </el-input>
                        <remarkModel
                                :remark.sync="form.remark"
                                ref="remarkModel"
                        ></remarkModel>
                </div>
                </template>
                <template slot="attachList">
                        <vupload
                                :fileList.sync="form.attachList"
                                :disabled="false"
                                :showButton="true"
                        ></vupload>
                </template>

                <template slot="menuForm">
                    <el-button @click="handleClose" ><span class="el-icon-close"></span> 取 消</el-button>
                </template>
            </avue-form>
        </el-dialog>
    </div>
</template>
<script>
import {
    delayOption,
} from "./option.js";
import {
        getRemarkList,
        delay,
 } from "@/api/crmedical/order/order-list/order-list";
import remarkModel from "../components/remark-model";
import vupload from "@/views/components/v-upload";
import {fieldDetail} from "@/api/v4ward/ordersetting/setting/selfForm"
export default {
    components:{
        remarkModel,vupload
    },
    data(){
        return{
            dialogFull:false,
            form:{
                attachList:[],
            },
            treeFormAreaData:[],//懒加载区域树 --报修表单中
            data:{},
            cheackedPeople:[],
            userList:[],
            groupList:[],
            dialogShow:false,
            option:delayOption,
            orderId:'',
            imgRequireFlag:false,
        }
    },
    methods:{
         //获取字段填写修饰
        async getFieldDetail(projectId,moduleType,actionType){
            console.log("执行了")
            let obj = {
                projectId:projectId,
                moduleType:moduleType,
                actionType:actionType
            }
            let fieldObj
            fieldObj  = this.findObject(this.option.column,'remark')
            let delayEndTimeObj = this.findObject(this.option.column,'delayEndTime')
            await fieldDetail(obj).then(res=>{
                let resField
                let resUploadFile,delayEndTime
                res.data.forEach(item=>{
                    if(item.fieldCode == "delayReason"){
                        resField =item
                    }
                    if(item.fieldCode == "uploadFile"){
                        resUploadFile =item
                    }
                     if(item.fieldCode == "delayEndTime"){
                        delayEndTime =item
                    }
                })
                if(resField){
                    if( resField.defaultMustFlag ==0){

                    fieldObj.rules[0].required=false
                    }else{
                        fieldObj.rules[0].required=true
                    }
                }
                if(resUploadFile){
                    if( resUploadFile.defaultMustFlag ==0){

                        this.imgRequireFlag=false
                    }else{
                        this.imgRequireFlag=true
                    }
                }
                if(delayEndTime){
                     if( delayEndTime.defaultMustFlag ==0){

                    delayEndTimeObj.rules[0].required=false
                    }else{
                        delayEndTimeObj.rules[0].required=true
                    }
                }

            })
        },
        // 弹窗关闭前
        handleClose(done){
                let self = this;
                this.$confirm('确认关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                })
                .then(()=> {

                        self.dialogShow = false;

                })
                .catch(()=> {

                });
        },
        openDialog(data){
                this.title = data.title;
                let orderRow = data.orderRow
                 this.getFieldDetail(orderRow.projectId,orderRow.moduleType,6)
            this.dialogShow = true;
            console.log("openDialog")
            this.orderId = data.orderId;
            this.form = {
                orderId:data.orderId,
                 attachList:[],
            }
            this.initData();

        },
        closeDialog(){
            this.dialogShow = false;
        },
        formError(done){
            done()
        },

        formSubmit(form,done){
            if(this.imgRequireFlag){
                if(this.form.attachList.length==0){
                    this.$message.error("请上传照片或视频")
                    done()
                    return
                }
            }

            delay(form).then(res=>{
                if(res.msg=='操作成功'){
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                     this.dialogShow = false;
                }else{
                    this.$message.error(res.msg);
                }
                this.$emit('handleClose',function(){console.log('关闭历程表')})

                this.dialogShow = false;
                done()
            }).catch(err=>{


                done()
            })
        },
        // 初始化数据
        async initData(){

            // 获取备注模板
            await getRemarkList({orderId:this.orderId,actionType:6}).then(res=>{
                this.$refs.remarkModel.setRemarkList(res.data);
            })
        },


    }
}
</script>
